// extracted by mini-css-extract-plugin
module.exports = {"eventsWrapper":"BannerWidgetEvents_eventsWrapper__3J380"};